import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Wrapper = styled.div`
    cursor: pointer;
    ${FlexCentered}
`
